import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserUnifiedFacade } from '@thiememeulenhoff/ng-store';
import { catchError, map, of, tap } from 'rxjs';
import { AuthenticationService } from '../_services';

export const adminAccessGuard: CanActivateFn = () => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  const userUnifiedFacade = inject(UserUnifiedFacade);

  return authenticationService.login().pipe(
    tap(() => userUnifiedFacade.initialize()),
    map(() => {
      if (authenticationService.hasAdminLicense()) {
        return true;
      }

      return router.parseUrl('/forbidden');
    }),
    catchError(() => of(router.parseUrl('/forbidden'))),
  );
};
